module.exports = "/images/vendor/greenmotion-shared/Components/quotes/gm-icon-grey.svg?8c9064d0c7018d8a6e0c7cccd674f594";


//////////////////
// WEBPACK FOOTER
// ./node_modules/greenmotion-shared/Components/quotes/images/gm-icon-grey.svg
// module id = 5w06
// module chunks = 22